module.exports = __webpack_public_path__ + "img/romantik-guide2.b931f776.jpg";